import { debounce } from 'lodash'
import { parseLink } from '../../../services/parselinkService'

export default {
  data() {
    return {
      isOpen: false,
      localeName: '&nbsp;',
    }
  },

  computed: {
    getLocaleName() {
      const locale = this.availableLocales.find(locale => locale.code === this.getLocale)

      return locale.name
    },

    getLocale() {
      return this.$i18n.locale
    },

    availableLocales() {
      return this.$i18n.locales
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.localeItems = this.$refs.items
      this.amoutOfLocaleItems = this.localeItems.childElementCount
      this.firstLocaleItem = this.localeItems.firstChild

      window.addEventListener('keyup', this.keyup)
      window.addEventListener('resize', this.resize)
      window.dispatchEvent(new Event('resize'))
    })

    this.localeName = this.getLocaleName
  },

  beforeDestroy() {
    window.removeEventListener('keyup', this.keyup)
    window.removeEventListener('resize', this.resize)
  },

  methods: {
    resize(e) {
      this.resizeDebounce(e, this)
    },

    resizeDebounce: debounce((e, self) => {
      const localeItemHeight = self.firstLocaleItem.offsetHeight

      self.heightOfCloseItems = localeItemHeight
      self.heightOfOpenItems = self.amoutOfLocaleItems * localeItemHeight

      self.close()
    }, 100),

    open() {
      this.isOpen = true

      this.localeItems.style.height = `${this.heightOfOpenItems}px`
    },

    close() {
      this.isOpen = false

      this.localeItems.style.height = `${this.heightOfCloseItems}px`
    },

    keyup(e) {
      if (e.keyCode === 27 && this.isOpen) this.close()
    },

    parseLink(payload) {
      const { path, locale } = payload

      const route = locale ? `${this.switchLocalePath(locale)}` : path

      const newUrl = parseLink(route)

      return newUrl
    },
  },
}
